import { Box, Typography } from '@mui/material';
import ButtonActions from '../../../../../../components/ButtonActions';
import { useState } from 'react';
import { ResponsibleCard } from '../ResponsibleCard';
import Button from '../../../../../../components/button/Button';
import { getDate } from '../../../../../../utils/common';
import { TEST_IDS } from '../../testIds';
import {
    COLORES_DRAWER,
    DrawerSvccCuerpo,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

const ResponsibleForm = ({
    selectedRadiologicalEquipment,
    isEditing,
    responsibleForm,
    handleAddNewResponsible,
    localResponsibles,
    handleSubmit,
    handleDeleteLocalResponsibleClick,
    handleDeleteSaveResponsibleClick,
    handleCancelClick,
    onlyVisual,
    cargando = false
}: any) => {
    const {
        responsiblesFieldsConfig,
        formData,
        handleChange,
        errors,
        translate,
        validateForm,
        resetForm
    } = responsibleForm;
    const [showResponsibleForm, setShowResponsibleForm] = useState<boolean>(false);

    const responsablesGuardados = isEditing
        ? selectedRadiologicalEquipment?.responsables || []
        : [];
    const hayResponsables = localResponsibles?.length > 0 || responsablesGuardados.length > 0;

    const handleNewResponsibleClick = () => {
        if (!validateForm(formData, responsiblesFieldsConfig)) return;
        handleAddNewResponsible();
        resetForm();
        setShowResponsibleForm(false);
    };

    return (
        <>
            <DrawerSvccCuerpo>
                {showResponsibleForm && (
                    <DrawerSvccSeccion
                        titulo={translate('radiologicalEquipmentForm.titles.responsibleData')}
                    >
                        <CamposSvcc
                            config={responsiblesFieldsConfig}
                            formData={formData}
                            errors={errors}
                            onChange={handleChange}
                            onlyVisual={onlyVisual}
                        />
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <ButtonActions
                                renderBackAction
                                returnText={translate('radiologicalEquipmentForm.buttons.cancel')}
                                confirmText={translate(
                                    'radiologicalEquipmentForm.buttons.addResponsible'
                                )}
                                loading={false}
                                disabled={false}
                                handleClose={() => setShowResponsibleForm(false)}
                                onClick={handleNewResponsibleClick}
                                borderRadius="8px"
                                position="flex-end"
                                size="small"
                            />
                        </Box>
                    </DrawerSvccSeccion>
                )}

                <DrawerSvccSeccion>
                    {/* Encabezado propio de la sección: el título y, a la derecha, la acción. */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={1.5}
                        mb={1.75}
                    >
                        <Typography
                            component="h3"
                            sx={{ fontSize: 14, fontWeight: 700, color: COLORES_DRAWER.texto }}
                        >
                            {translate('radiologicalEquipmentForm.titles.responsablesCargados')}
                        </Typography>
                        {!onlyVisual && (
                            <Button
                                disabled={showResponsibleForm}
                                type="contained"
                                onClick={() => setShowResponsibleForm(true)}
                                loading={false}
                                testID={TEST_IDS.newRadiologicalEquipment.buttons.newResponisble}
                            >
                                {translate('radiologicalEquipmentForm.buttons.newResponsible')}
                            </Button>
                        )}
                    </Box>

                    {hayResponsables ? (
                        <Box display="flex" flexDirection="column" gap={1.25}>
                            {localResponsibles.map((localResponsible: any, index: number) => (
                                <ResponsibleCard
                                    key={`local-${index}`}
                                    name={localResponsible?.nombre}
                                    surname={localResponsible?.apellido}
                                    cuit={localResponsible?.cuit}
                                    permission={localResponsible?.permiso}
                                    licenseNumber={localResponsible?.matricula}
                                    expeditionDate={localResponsible?.fechaExpedicion}
                                    expirationDate={localResponsible?.fechaVencimiento}
                                    type={localResponsible?.idTipoResponsable}
                                    otherData={''}
                                    handleDeleteClick={() =>
                                        handleDeleteLocalResponsibleClick(index)
                                    }
                                    translate={translate}
                                    onlyVisual={onlyVisual}
                                />
                            ))}
                            {responsablesGuardados.map((responsible: any) => (
                                <ResponsibleCard
                                    key={`guardado-${responsible?.id}`}
                                    name={responsible?.nombre}
                                    surname={responsible?.apellido}
                                    cuit={responsible?.cuit}
                                    permission={responsible?.permiso}
                                    licenseNumber={responsible?.matricula}
                                    expeditionDate={getDate(responsible?.fechaExpedicion)}
                                    expirationDate={getDate(responsible?.fechaVencimiento)}
                                    type={responsible?.idTipoResponsable}
                                    otherData={''}
                                    handleDeleteClick={() =>
                                        handleDeleteSaveResponsibleClick(responsible?.id)
                                    }
                                    translate={translate}
                                    onlyVisual={onlyVisual}
                                />
                            ))}
                        </Box>
                    ) : (
                        <Typography variant="body2" sx={{ color: COLORES_DRAWER.textoSuave }}>
                            {translate('radiologicalEquipmentForm.sinResponsables')}
                        </Typography>
                    )}
                </DrawerSvccSeccion>
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCancelClick}
                onConfirmar={handleSubmit}
                textoCancelar={translate('radiologicalEquipmentForm.buttons.cancel')}
                textoConfirmar={translate('radiologicalEquipmentForm.buttons.save')}
                nota={
                    onlyVisual
                        ? undefined
                        : translate('radiologicalEquipmentForm.notaPaso', { paso: 3 })
                }
                cargando={cargando}
                sinConfirmar={onlyVisual}
            />
        </>
    );
};

export default ResponsibleForm;
